import { z } from 'zod';

export enum DiagramChatChannelType {
    TEAM = 'team',
    COLLABORATOR = 'collaborator',
    ENGINEERING_SUPPORT = 'engineering-support',
    MANUFACTURING_SUPPORT = 'manufacturing-support',
    FEATURE_REQUEST = 'feature-request',
}

export type DepSupportChannelType = DiagramChatChannelType.ENGINEERING_SUPPORT | DiagramChatChannelType.FEATURE_REQUEST;

export const DiagramChatChannelCollaboratorSchema = z.object({
    id: z.string(),
    project: z.string(),
    channel: z.string(),
    user: z.string(),
});

export const DiagramChatChannelCompanySchema = z.object({
    id: z.string(),
    project: z.string(),
    channel: z.string(),
    company: z.string(),
    // Companies that work on behalf of the company. Hidden from the end user: only the company and
    // the subcontractors themselves get them back.
    subcontractors: z.string().array().nullish(),
});

export const DiagramChatChannelSchema = z.object({
    id: z.string(),
    name: z.string(),
    project: z.string(),
    type: z.nativeEnum(DiagramChatChannelType),
    access: z
        .object({
            users: z
                .object({
                    docs: z.string().array().optional().default([]),
                })
                .optional()
                .default({}),
            companies: z
                .object({
                    docs: z.string().array().optional().default([]),
                })
                .optional()
                .default({}),
        })
        .default({}),
    views: z
        .object({
            user: z.string(),
            date: z.date(),
        })
        .array()
        .default([]),
    viewed: z.boolean(),
    createdBy: z.string(),
    createdAt: z.date(),
    team: z.string(),
});

export const DiagramChatChannelListParamsSchema = z.object({
    page: z.number().optional().default(1),
    depth: z.number().optional().default(0),
    sort: z.string().optional().default('-createdAt'),
    withoutInternal: z.boolean().optional().default(false),
    limit: z.number().optional().default(24),
    company: z.string().optional(),
});
